module.exports = __webpack_public_path__ + "static/media/20_negro.6a719d5b.svg";